import preloaded from '../../src/preloaded';
import Feed from '../../src/feed/2022/Feed.jsx';
import mountFeed from '../../src/feed/2022/mountFeed.js';

const target = document.getElementById('feedContainer');

mountFeed(target, Feed, preloaded.feed_url);
